import { gql, useQuery } from "@apollo/client";
import { restaurant } from "../apollo/server";

const RESTAURANT = gql`
  ${restaurant}
`;

export default function useRestaurant(id, slug, stopId = null) {
  const { data, refetch, networkStatus, loading, error } = useQuery(RESTAURANT, {
    variables: { id, slug, stopId },
    // Was network-only, which meant a two second blank screen on every single
    // visit, even straight back to a menu just viewed. cache-and-network paints
    // the known menu at once and refreshes it underneath; the screen already
    // renders on `loading && data`, so a stale price is only ever on screen for
    // the length of the refetch.
    //
    // A food-truck stop's menu (stopId) is the same Restaurant and AdvancedMenu
    // ids with that stop's items, prices and counts. Cached, it would overwrite
    // the regular menu under those ids and the other way round, so it never
    // touches the cache. The server keeps its own warm copy, so it stays quick.
    fetchPolicy: stopId ? "no-cache" : "cache-and-network",
  });
  return { data, refetch, networkStatus, loading, error };
}
